﻿import {isNullOrEmpty, translation} from "@2d-front-monorepo/core";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {CustomData} from "../CustomData";
import ICustomData from "../interfaces/ICustomData";

export interface ConstructionNumberProps {
	data: ICustomData;
	keyName: string;
}

export default function ConstructionNumber({data, keyName}: ConstructionNumberProps): JSX.Element {
	const constructionNumber = CustomData.get(data, keyName) ?? "";
	if (isNullOrEmpty(constructionNumber)) {
		return <></>;
	}

	return (
		<div className="card card--padded">
			<dl className="title-desc">
				<dt>{translation(PermitTranslations.new_reservation_page__purpose__construction_label)}</dt>
				<dd>{constructionNumber}</dd>
			</dl>
		</div>
	);
}
